<script setup lang="ts">
import type { NotificationType } from '@/types/models';
import { twMerge } from '@foodics/ui-common';
import { type Component } from 'vue';
import FdxIconArrowUpward from '~icons/icon/arrow-upward';
import FdxCashflowIconAvatarCircle from '~icons/cashflow-icon/avatar_circle';
import FdxCashflowIconFoodicsPay from '~icons/cashflow-icon/foodics_pay';
import FdxCashflowIconSadad from '~icons/cashflow-icon/sadad';
import FdxIconCheckCircleOutline from '~icons/icon/check-circle-outline';
import FdxIconInfoOutline from '~icons/icon/info-outline';
import FdxCashflowIconCollection from '~icons/cashflow-icon/collection';
import { notificationTypeEnum } from '@/enums/notifications';

const props = defineProps<{
    type: NotificationType;
}>();

const iconConfigMap: Record<
    NotificationType,
    { bgClass: string; iconClass: string; icon: Component }
> = {
    [notificationTypeEnum.INCOMING_TRANSFER]: {
        bgClass: 'bg-positive-100',
        iconClass: 'text-positive-500 rotate-180',
        icon: FdxIconArrowUpward,
    },
    [notificationTypeEnum.OUTGOING_TRANSFER_SUCCESSFUL]: {
        bgClass: ' bg-gray-200',
        iconClass: 'text-gray-1000',
        icon: FdxIconArrowUpward,
    },
    [notificationTypeEnum.FOODICS_PAY_DAILY_SUMMARY]: {
        bgClass: 'bg-primary-100',
        iconClass: 'text-primary-400',
        icon: FdxCashflowIconFoodicsPay,
    },
    [notificationTypeEnum.NEW_MEMBER_JOINED]: {
        bgClass: 'bg-primary-100',
        iconClass: 'text-primary-500',
        icon: FdxCashflowIconAvatarCircle,
    },
    [notificationTypeEnum.TRANSACTIONS_EXPORT_READY]: {
        bgClass: 'bg-positive-100',
        iconClass: 'text-positive-500',
        icon: FdxIconCheckCircleOutline,
    },
    [notificationTypeEnum.APPROVAL_RULE_UPDATED]: {
        bgClass: 'bg-secondary-100',
        iconClass: 'text-secondary-500',
        icon: FdxIconInfoOutline,
    },
    [notificationTypeEnum.SADAD_BILL_PAID]: {
        bgClass: 'bg-gray-200',
        iconClass: 'text-primary-500',
        icon: FdxCashflowIconSadad,
    },
    [notificationTypeEnum.COLLECTION_SUCCESSFUL]: {
        bgClass: ' bg-gray-200',
        iconClass: 'text-gray-1000',
        icon: FdxCashflowIconCollection,
    },
};

const iconConfig = iconConfigMap[props.type];
</script>

<template>
    <div
        :class="
            twMerge(
                'size-10 rounded-full flex items-center justify-center shrink-0',
                iconConfig.bgClass,
            )
        "
    >
        <component
            :is="iconConfig.icon"
            :class="twMerge('size-6 text-gray-1000', iconConfig.iconClass)"
        />
    </div>
</template>
